import React, { createContext, useContext, useState, useCallback, useMemo } from "react";
import { dict } from "@/lib/i18n";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("crm_lang") || "id");

  const toggle = useCallback(() => {
    setLang((prev) => {
      const next = prev === "id" ? "en" : "id";
      localStorage.setItem("crm_lang", next);
      return next;
    });
  }, []);

  const t = useCallback((key) => dict[lang]?.[key] ?? key, [lang]);

  const value = useMemo(() => ({ lang, setLang, toggle, t }), [lang, toggle, t]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be inside LangProvider");
  return ctx;
};
